import { useDispatch, useSelector } from 'react-redux';
import { ResumenTransaccionRow } from './ResumenTransaccionRow';
import { CurrencyUtils } from '../../common/CurrencyUtils';
import { QueryByType } from '../../domain/constants/QueryByType';
import { ModalMovActions } from '../../presentation/redux/actions/ModalMovActions';
import { ModalMovState } from '../../presentation/redux/states/ModalMovState';
import { RootState } from '../../presentation/redux/store/RootState';
import { useContext } from 'react';
import authContext from '../../context/auth/authContext';
//import { BalanceActions } from '../../presentation/redux/actions/BalanceActions';

export function ResumenTransaccion() {

    const listado = useSelector((s: RootState) => s.balanceState.historic);
    const dispatch = useDispatch();


    const AuthContext = useContext(authContext);
    const { token } = AuthContext;

    /* useEffect(() => {
        dispatch(BalanceActions.updateHistoric(token));
    }, [ token, dispatch]) 
    */

    function handleTextOverflow(text: string | null | undefined): string {
        if (!text) return '';
        if (text.length <= 12) return text;
        let shortText: string = text.substring(text.length - 12, text.length);
        return `...${shortText}`;
    }

    const handleOpen = (mt: string) => {
        switch (mt) {
            case 'day':
                dispatch(
                    ModalMovActions.open(
                        new ModalMovState({
                            title: "Histórico",
                            date: new Date(),
                            isResume: false,
                            isCustom: false,
                            queryType: QueryByType.DATE,
                            token: token,
                        })
                    ));
                break
            case 'month':
                dispatch(
                    ModalMovActions.open(
                        new ModalMovState({
                            title: "Histórico",
                            date: new Date(),
                            isResume: false,
                            isCustom: false,
                            queryType: QueryByType.MONTH,
                            token: token,
                        })
                    ));
                break
            case 'last_month':
                const date = new Date();
                date.setMonth(date.getMonth() - 1);
                dispatch(
                    ModalMovActions.open(
                        new ModalMovState({
                            title: "Histórico",
                            date: date,
                            isResume: false,
                            isCustom: false,
                            queryType: QueryByType.MONTH,
                            token: token,
                        })
                    ));
                break
            default:
                dispatch(
                    ModalMovActions.open(
                        new ModalMovState({
                            title: "Histórico",
                            date: new Date(),
                            isResume: false,
                            isCustom: true,
                            queryType: QueryByType.DATE,
                            token: token,
                        })
                    ));
        }
    }

    // cresumen
    return (
        <div className="row  cardNeu  mx-1 mb-4 py-2">
            <div className="col">
                <div className="row">
                    <div className="col">
                        <h4 className="lvender text-center pt-3">Histórico</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <table className="table tableHistorico">
                            <thead>
                                <tr>
                                    <td colSpan={4}>
                                        <h1 className="text-center lventa mt-2">
                                            Últimas 5 Transacciones
                                        </h1>
                                    </td>
                                </tr>
                            </thead>
                            <tbody className="tableHistoricoResults">
                                {
                                    (listado ?? []).slice(0, 10).map((e, index) => {
                                        return <ResumenTransaccionRow
                                            key={`${e.date_hour}${index}`}
                                            destination={handleTextOverflow(e.destination)}
                                            carrier={e.carrier}
                                            amount={CurrencyUtils.moneyFormat(e.amount)}
                                            isSuccess={e.rcode === 0} />
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="button-grid">
                    <button type="button" onClick={() => handleOpen('day')}
                        className="btn btnPrimary btn-transparent">Reporte del día
                    </button>
                    <button type="button" onClick={() => handleOpen('month')}
                        className="btn btnPrimary btn-transparent">Mes actual
                    </button>
                    <button type="button" onClick={() => handleOpen('last_month')}
                        className="btn btnPrimary btn-transparent">Mes anterior
                    </button>
                    <button type="button" onClick={() => handleOpen('custom')}
                        className="btn btnPrimary btn-transparent">Personalizado
                    </button>
                </div>
            </div>
        </div>);
}